export const EVENT_REQUEST = "EVENT.EVENT_REQUEST";
export const EVENT_SUCCESS = "EVENT.EVENT_SUCCESS";
export const EVENT_FAILURE = "EVENT.EVENT_FAILURE";

export const GET_SINGLE_EVENT_REQUEST = "EVENT.GET_SINGLE_EVENT_REQUEST";
export const GET_SINGLE_EVENT_SUCCESS = "EVENT.GET_SINGLE_EVENT_SUCCESS";
export const GET_SINGLE_EVENT_FAILURE = "EVENT.GET_SINGLE_EVENT_FAILURE";

export const CREATE_EVENT_REQUEST = "EVENT.CREATE_EVENT_REQUEST";
export const CREATE_EVENT_SUCCESS = "EVENT.CREATE_EVENT_SUCCESS";
export const CREATE_EVENT_FAILURE = "EVENT.CREATE_EVENT_FAILURE";

export const UPDATE_EVENT_REQUEST = "EVENT.UPDATE_EVENT_REQUEST";
export const UPDATE_EVENT_SUCCESS = "EVENT.UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_FAILURE = "EVENT.UPDATE_EVENTP_FAILURE";

export const DELETE_EVENT_REQUEST = "EVENT.DELETE_EVENT_REQUEST";
export const DELETE_EVENT_SUCCESS = "EVENT.DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAILURE = "EVENT.DELETE_EVENT_FAILURE";

export const CREATE_INTEREST_REQUEST = "EVENT.CREATE_INTEREST_REQUEST";
export const CREATE_INTEREST_SUCCESS = "EVENT.CREATE_INTEREST_SUCCESS";
export const CREATE_INTEREST_FAILURE = "EVENT.CREATE_INTEREST_FAILURE";

export const SET_REDIRECT_TO = "EVENT.SET_REDIRECT_TO";
